// Products.jsx
import React from "react";
import "./Products.css";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Iphone from "../../../Assets/Product_Imgs/Pill=true, Color=Gold.png";

const Products = () => {
  return (
    <>
      <Helmet>
        <title>Products - Valsco</title>
        <meta
          name="description"
          content="Discover our range of innovative products designed to enhance your experience. For all your software solutions, explore the future with Valsco."
        />
        <link rel="canonical" href="/products" />
      </Helmet>

      <section className="products_page" style={{ overflowX: "hidden" }}>
        <div className="products_container">
          {/* Left side: Phone image */}
          <div className="products_image">
            <Link to="https://www.jurident.com/">
              <img
                src={"../jurident-mobile.png"}
                alt="Jurident App"
                className="default-img"
              />
              <img
                src={Iphone}
                alt="Jurident App"
                className="hero_products_photo"
              />
            </Link>
          </div>

          {/* Right side: Text */}
          <div className="products_text">
            <h1 className="products_heading_large">
              Our <br /> Product
            </h1>

            <p
              style={{
                fontFamily: "Poppins Light",
                fontWeight: "Light",
                fontSize: "1.5rem",
                lineHeight: 1.8,
                color: "#333333",
                marginTop: "15px",
              }}
            >
              <Link
                to="https://www.jurident.com/"
                style={{
                  fontSize: "45px",
                  fontStyle: "light",
                  fontWeight: 300,
                  color: "#00004dff",
                  fontFamily: "Clash Display",
                  textDecoration: "none",
                }}
              >
                Jurident 
              </Link>
               &nbsp; is a mobile application targeted towards betterment of legal
              productivity and management. Explore its features designed to
              streamline case management, tasks, and client interactions
              efficiently
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Products;
